export interface SqlArguments {
    property: string,
    value: number | string | boolean,
    operation?: string,
    equality?: string,
    type?: string,
    openParenthesis?: string,
    closeParenthesis?: string,
};